import { render, staticRenderFns } from "./SuspensionData.vue?vue&type=template&id=6ad3250c&"
import script from "./SuspensionData.vue?vue&type=script&lang=js&"
export * from "./SuspensionData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports